import useFetch from 'app/hooks/useFetch'
import {useSelector} from 'react-redux'
import { MONTHS } from '../minutas/minutaList/dataList'


type UseTableCost = () => {
  table: any[],
  series: any[],
  error?: boolean
}

const useTableCost: UseTableCost = () => {
  const {user} = useSelector(({auth}: any) => auth)
  const id: any = user.idUser ? user.idUser : user.id
  const { data: cumplimientosCostos, error } = useFetch('amd_cumplimientos_costos', {
    parametros: [{text: 'usuario', value: id.toString()}],
  })

  const costoMinutasLeyenda: any[] = [['Minuta sobre costo AMD'], ['Minuta sobre costo Sitio'], ['Minuta en costo AMD'], ['Minuta en costo Sitio'], ['Minuta bajo costo AMD'], ['Minuta bajo costo Sitio']]
  const dataAMD: any[] = cumplimientosCostos.filter((e: any) => e.version === 1).sort((a: any, b: any) => a.mes - b.mes)
  const dataSitio: any[] = cumplimientosCostos.filter((e: any) => e.version === 3).sort((a: any, b: any) => a.mes - b.mes)
  const hasMonth: any[] = dataAMD.map((e: any) => MONTHS.find((m: any) => m.value === e.mes))
  const headerCostoMinuta: any[] = hasMonth.map((e: any) => e.text)
  headerCostoMinuta.unshift('#')
  const tableCostoMinuta: any[] = [
    dataAMD.map((e: any) => e.sobreCosto),
    dataSitio.map((e: any) => e.sobreCosto),
    dataAMD.map((e: any) => e.enCosto),
    dataSitio.map((e: any) => e.enCosto),
    dataAMD.map((e: any) => e.bajoCosto),
    dataSitio.map((e: any) => e.bajoCosto),
  ]

  const dataTable: any[] = costoMinutasLeyenda.map((e: any[], i: number) => e.concat(tableCostoMinuta[i]))
  const table: any = {
    header: headerCostoMinuta,
    data: dataTable,
  }
  const series: any[] = hasMonth.map((e: any, i: number) => {
    return {
      name: e.text,
      data: [
        dataSitio[i] ? dataSitio[i].bajoCosto : 0,
        dataAMD[i] ? dataAMD[i].bajoCosto : 0,
        dataSitio[i] ? dataSitio[i].enCosto : 0,
        dataAMD[i] ? dataAMD[i].enCosto : 0,
        dataSitio[i] ? dataSitio[i].sobreCosto : 0,
        dataAMD[i] ? dataAMD[i].sobreCosto : 0,
      ],
    }
  })

  return {table, series, error}
}

export default useTableCost
